import React, { useContext } from 'react';
// BrowserRouter as Router دیگر لازم نیست چون در index.js است
import { Routes, Route, Link } from 'react-router-dom'; 
import AuthContext from './context/AuthContext';

// --- وارد کردن تمام کامپوننت‌های صفحات ---
import LandingPage from './LandingPage';
import Register from './Register'; // کامپوننت ثبت نام همیار
import Login from './Login'; // کامپوننت ورود / ثبت نام خانواده
import Profile from './Profile';
import MyRequests from './MyRequests';
import RequestForm from './RequestForm';
import AvailableRequests from './AvailableRequests';
import ProviderPublicProfile from './ProviderPublicProfile';
import Dashboard from './Dashboard';
import MyBids from './MyBids';
import Blog from './Blog';
import ArticleDetail from './ArticleDetail';
import ContractView from './ContractView';
import PaymentResult from './PaymentResult';
import AdminLayout from './admin/AdminLayout';
import AdminOverview from './admin/AdminOverview';
import AdminProviders from './admin/AdminProviders';
import AdminRequests from './admin/AdminRequests';
import AdminContracts from './admin/AdminContracts';
import AdminServices from './admin/AdminServices';
import AdminPayouts from './admin/AdminPayouts';
import AdminSettings from './admin/AdminSettings';

// --- وارد کردن کامپوننت‌های MUI ---
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';

function App() {
    const { user, logoutUser } = useContext(AuthContext);

    // از Fragment <> استفاده می‌کنیم چون Router در index.js است
    return (
        <>
            <AppBar position="static" elevation={0}>
                 <Toolbar>
                    <Typography
                        variant="h6"
                        component={Link}
                        to="/"
                        sx={{ flexGrow: 1, color: 'primary.contrastText', textDecoration: 'none', fontWeight: 800 }}
                    >
                        الو یارا
                    </Typography>
                    
                    {user ? (
                        <>
                            {/* --- منوی کاربر لاگین کرده --- */}
                            <Typography sx={{ mx: 2 }}>خوش آمدید, {user.first_name || user.phone_number}</Typography>
                            <Button color="inherit" component={Link} to="/dashboard">داشبورد</Button>
                            <Button color="inherit" component={Link} to="/profile">پروفایل من</Button>
                            
                            {/* ✅ اصلاح: جایگزینی کامنت‌ها با دکمه‌های واقعی */}
                            {user.user_type === 'requester' && (
                                <>
                                    <Button color="inherit" component={Link} to="/create-request">ثبت درخواست</Button>
                                    <Button color="inherit" component={Link} to="/my-requests">درخواست‌های من</Button>
                                </>
                            )}
                            {user.user_type === 'provider' && (
                                <>
                                    <Button color="inherit" component={Link} to="/my-bids">پیشنهادهای من</Button>
                                    <Button color="inherit" component={Link} to="/available-requests">درخواست‌های جدید</Button>
                                </>
                            )}

                            {user.is_staff && (
                                <Button color="inherit" component={Link} to="/panel" sx={{ fontWeight: 800 }}>پنل مدیریت</Button>
                            )}
                            <Button color="inherit" onClick={logoutUser}>خروج</Button>
                        </>
                    ) : (
                        <>
                            {/* --- منوی کاربر مهمان (وارد نشده) --- */}
                            <Button color="inherit" component={Link} to="/blog">مقالات</Button>
                            <Button color="inherit" component={Link} to="/register">ثبت نام همیار</Button>
                            <Button color="inherit" component={Link} to="/login">ورود / ثبت‌نام</Button>
                        </>
                    )}
                </Toolbar>
            </AppBar>
            <Box sx={{ minHeight: '70vh' }}>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/my-requests" element={<MyRequests />} />
                    <Route path="/create-request" element={<RequestForm />} />
                    <Route path="/available-requests" element={<AvailableRequests />} />
                    <Route path="/providers/:userId" element={<ProviderPublicProfile />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/my-bids" element={<MyBids />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<ArticleDetail />} />
                    <Route path="/contracts/:requestId" element={<ContractView />} />
                    <Route path="/payment/result" element={<PaymentResult />} />
                    <Route path="/panel" element={<AdminLayout />}>
                        <Route index element={<AdminOverview />} />
                        <Route path="providers" element={<AdminProviders />} />
                        <Route path="requests" element={<AdminRequests />} />
                        <Route path="contracts" element={<AdminContracts />} />
                        <Route path="services" element={<AdminServices />} />
                        <Route path="payouts" element={<AdminPayouts />} />
                        <Route path="settings" element={<AdminSettings />} />
                    </Route>
                </Routes>
            </Box>
        </>
    );
}

export default App;

